import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { EditableProp, EditorProps } from '../../dom-generator/types';
import { CardSectionService } from '../../component/card-section/card-section-common';
import { WebClient } from '../../webclient/webclient.service';
import './card-organizer.less';
import * as $ from 'jquery';
import * as Packery from 'packery';
import * as Draggabilly from "draggabilly";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Typeahead } from 'react-bootstrap-typeahead';


interface CardOrganizerState {
    cardIds: Array<number>,
    cardGroups: Array<{ id: string, name: string }>,
    cards: Array<{ id: number, title: string, cardable_type: string, rendered: string }>
    selectedGroupId: string,
    selectedCardId: number,
    html: string,
    cardType: string,
    hovered: { id: number, title: string, rendered: string } | null
}



export class CardOrganizerService {

    private grid;

    public init(saveCallback: (order: Array<number>) => void, root: string = '', draggable = true) {
        CardSectionService.cardsHeightFix(root + ' .card-organizer');
        /*my baumit card nem volt kattintható*/
        // $(root + ' .card-organizer .grid-item').css('touch-action', 'auto').find('a').removeAttr('href');
        $(root + ' .card-organizer .grid-item.youtube').append('<div class="drag-overlay"></div>')
        if (this.grid) this.grid.destroy();
        $(root + ' .card-organizer .grid-item').find('.inner').fadeIn();
        if ($(root + ' .card-organizer .grid-item.small:not(.hidden)').length > 0) {
            this.grid = new Packery($(root + ' .card-organizer .grid').get(0), {
                itemSelector: '.grid-item',
                columnWidth: '.small:not(.hidden)'
            });
        }
        else {
            this.grid = new Packery($(root + ' .card-organizer .grid').get(0), {
                itemSelector: '.grid-item',
                columnWidth: '.medium:not(.hidden)'
            });
        }

        if (draggable) {

            $(root + ' .card-organizer .grid').find('.grid-item').each((i, gridItem) => {
                $(gridItem).find('.inner').append($('<div class="delete-btn"><i class="fa fa-trash-o"></i></div>'));
                var draggie = new Draggabilly(gridItem);
                this.grid.bindDraggabillyEvents(draggie);
                draggie.on('dragEnd', (event, pointer) => {
                    saveCallback(this.getOrder())
                })
            });
        }

        $(root + ' .card-organizer .grid').on('click', '.grid-item .delete-btn, .actionSignedInDeleteFromDashboard', ev => {
            this.grid.remove($(ev.target).closest('.grid-item').get(0));
            this.grid.shiftLayout();
            ev.stopPropagation();
            saveCallback(this.getOrder())
            return false;
        });

        $(window).resize(() => CardSectionService.cardsHeightFix(root + ' .card-organizer'));
    }


    private getOrder = () => {
        var order = [];
        var elements = this.grid.getItemElements();
        $(elements).each(function (i, el) {
            order.push($(el).attr('data-card-id'));
        });
        return order;
    }

}

export class CardOrganizer extends React.Component<EditorProps, CardOrganizerState> {

    constructor(props) {
        super(props);
        //console.log(props);
        this.state = { cardIds: this.props.editValue, html: '', cardGroups: [], cards: [], selectedGroupId: ' ', cardType: this.props.params['cardType'], hovered: null, selectedCardId: -1 };

    }

    private subTitle: string = 'Card-organizer';
    private cardOrganizerService: CardOrganizerService = new CardOrganizerService();
    private cardTypeahead;

    private valueChange() {
        this.props.valueChangedCallback('cardIds', this.state.cardIds)
    }



    componentDidMount() {
        $('.editor-root').css({ maxHeight: '100%', overflow: 'auto' });
        if (this.state.cardIds.length) {
            WebClient.getCardsById(this.state.cardIds, this.state.cardType).then(result => {
                this.setState({
                    html: CardSectionService.getSortedCardsHtml((result as any).renderedCards, this.state.cardIds)
                }, () => {
                    setTimeout(() => this.cardOrganizerService.init(this.saveOrder), 500);
                });
            });
        }
        WebClient.getCards().then(this.processCardData);
        $('.editor-root').on('mouseenter', '.list-item', (ev) => {
            $('.card-preview').show();
            this.hoverItem(ev);

        });


    }


    private hoverItem = (ev) => {
        let attr = $(ev.target).closest('.list-item').attr('data-id');
        if (attr) {
            let id = parseInt(attr);
            if (id && (!this.state.hovered || id != this.state.hovered.id)) {
                let hovered = this.state.cards.filter(item => item.id == id);
                if (hovered && hovered.length > 0)
                    this.setState({ ...this.state, hovered: hovered[0] })
            }
        }
    }



    private saveOrder = (order) => { this.setState({ cardIds: order }, this.valueChange) };

    private processCardData = (data) => {
        let groups = [];
        for (let item in data.cardGroups) groups.push({ id: item, name: data.cardGroups[item] });
        this.setState({
            cards: data.cards.map(card => {
                if (card.cardable_type == null) card.cardable_type = '';
                return card;
            }),
            cardGroups: groups,
            selectedGroupId: groups[0].id
        }, () => console.log(this.state));
    }

    private groupChanged = () => {
        this.setState({ selectedGroupId: (this.refs.groupSelect as any).value });
    }

    private selectCard = sel => {
        if (sel.length > 0)
            this.setState({ ...this.state, selectedCardId: sel[0].id, hovered: null });
        else
            this.setState({ ...this.state, selectedCardId: null, hovered: null });
    }

    private blurCardSelect = ev => this.setState({ ...this.state, hovered: null });

    private addCard = () => {
        let id = this.state.selectedCardId;
        if (id < 0) return;
        let idx = this.state.cardIds.indexOf(id);
        let cardIds = this.state.cardIds;
        if (idx > -1) {
            cardIds.splice(idx, 1);
        }
        cardIds.push(id);
        WebClient.getCardsById(cardIds, this.state.cardType).then(result => {
            this.setState({
                cardIds: cardIds,
                html: CardSectionService.getSortedCardsHtml((result as any).renderedCards, cardIds)
            },
                () => {
                    this.cardOrganizerService.init(this.saveOrder);
                    this.valueChange();
                });
        });
        this.cardTypeahead.getInstance().clear();
        this.setState({ ...this.state, selectedCardId: -1 })
    }


    render() {
        return (
            <div className="editor-item">

                <div className="card-section-component card-organizer" style={{ maxWidth: '1600px', margin: 'auto' }}>
                    <div className="d-flex justify-content-start">
                        <label className="editor-title mr-2" dangerouslySetInnerHTML={{ __html: this.props.propData.displayName }}></label>
                        <label className="editor-subtitle">{this.subTitle}</label>
                    </div>
                    <div className="row">
                        <div className="col-md-2 mb-5">
                            <div className="card-data">
                                <div className="editor-item">
                                    <label className="editor-subtitle">Card Groups</label>
                                    <select id="card-goup-select" ref="groupSelect" onChange={this.groupChanged}>
                                        {this.state.cardGroups.map(group => <option key={group.id} value={group.id}>{group.name}</option>)}
                                    </select>
                                    <div className="card-preview" style={{ display: this.state.hovered ? 'block' : 'none' }} dangerouslySetInnerHTML={{ __html: this.state.hovered ? this.state.hovered.rendered : '' }}></div>
                                </div>
                                <div className="editor-item card-selector">
                                    <label className="editor-subtitle">Cards</label>
                                    <Typeahead
                                        options={this.state.cards.filter(card => card.cardable_type == this.state.selectedGroupId)}
                                        labelKey="title"
                                        valueKey="id"
                                        ref={(ref) => this.cardTypeahead = ref}
                                        onChange={this.selectCard}
                                        onBlur={this.blurCardSelect}
                                        renderMenuItemChildren={(option, props, index) => {
                                            return (<div className="list-item" data-id={option.id}>{option.title}</div>);
                                        }}

                                    />
                                    {/* <select id="card-select" ref="cardSelect">
                                        {this.state.cards.filter(card => card.cardable_type == this.state.selectedGroupId).map(card => <option key={card.id} value={card.id}><a className="card-option">{card.title}</a></option>)}
                                    </select> */}
                                </div>
                                <button id="addCard" disabled={this.state.selectedCardId < 0} className="button type-2 mt-3 full" onClick={this.addCard}>Add Card</button>
                            </div>
                        </div>
                        <div className="col-md-12 fix-width-card-organizer">
                            <div className="grid-bg">
                                <div className="grid" dangerouslySetInnerHTML={{ __html: this.state.html }}>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}